import styled from 'styled-components';

interface MainContainerProps {
  headerHeight: number;
  footerHeight: number;
  navigationBarHeight: number;
  promoBarHeight: number;
}

export const MainContainer = styled.main<MainContainerProps>`
  --headerNavBarHeight: ${({ headerHeight, navigationBarHeight, promoBarHeight }) =>
    headerHeight + navigationBarHeight + promoBarHeight}px;

  position: relative;
  z-index: 1;
  min-height: calc(100% - ${({ footerHeight }) => footerHeight}px);
  padding-top: calc(var(--headerNavBarHeight));
  overflow: hidden;
`;
